<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head1">CONTENTS</p>
<p class="toc"><a href="#/Introduction">Introduction: The Lake Michigan Triangle</a></p>
<p class="toc1"><a href="#/Chapter1#C1">The Unfriendly Skies</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">The Fury of the Waves</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">Visitors from the Unknown</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">Strange Creatures Stalking the Shoreline</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">Assorted Oddities</span></p>
<p class="toc1"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?943bd894